<div class="snackbar-stack">
  @for (message of messages(); track message.timestamp; let i = $index) {
    <div class="snackbar" [class.leaving]="message.leaving">
      {{ message.msg }}
      <button mat-icon-button class="close-btn" (click)="onClose(i)">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
